import React, { Component } from 'react';

class Root extends Component {
  render() {
    return <div>Root Component</div>;
  }
}

export default Root;
